import { render, staticRenderFns } from "./addPrice.vue?vue&type=template&id=a92d1e76&scoped=true&"
import script from "./addPrice.vue?vue&type=script&lang=js&"
export * from "./addPrice.vue?vue&type=script&lang=js&"
import style0 from "./addPrice.vue?vue&type=style&index=0&id=a92d1e76&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a92d1e76",
  null
  
)

export default component.exports